// extracted by mini-css-extract-plugin
export default {"notifications-header-container":"Notifications_notifications-header-container__+1caC","notification-switch-text":"Notifications_notification-switch-text__QGTRI"};